/*
 * @Author: Hyman Choi
 * @Date: 2021-01-11 08:39:36
 * @LastEditTime: 2022-02-09 15:37:37
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \Siui.Cloud.Medical.Web\src\lang\en.js
 */
/*
 * @Author: Latte
 * @Date: 2021-05-27 16:34:31
 * @LAstEditors: Latte
 * @LastEditTime: 2021-09-10 11:35:12
 * @FilePath: \Siui.Cloud.Medical.Web\src\lang\zh.js
 */

export default {
	// Common
	tips: "Tips",
	yes: "Yes",
	no: "No",
	search: "Search",
	reset: "Reset",
	edit: "Edit",
	delete: "Detele",

	// route
	route: {
		SIUICloud: "SIUI Cloud",
		home: "Home",
		userSetting: "User Setting",
		modifyPassword: "Modify Password",
		accountSetting: "Account Setting",
		authentication: "Authentication",
		feedback: "Feedback",
		cloudStorage: "Cloud Storage",
		myFiles: "My Files",
		myReport: "My Report",
		reportTemplate: "Report Template",
		reportThesaurus: "Report Thesaurus",
		comparison: "Comparison",
		cloudConsultation: "Cloud Consultation",
		createConsultation: "Create Consultation",
		myConsultation: "My Consultation",
		receiveConsultation: "Receive Consultation",
		cloudTeaching: "Cloud Teaching",
		cloudResourceManagement: "Cloud Resource Management",
		resourcePreview: "Resource Preview",
		cloudService: "Cloud Service",
		messageList: "Message List",
		staffList: "Staff List",
		mai: "MAI",
		couponManagement: "Coupon Management",
		IntegralRules: "Integral Rules",
		integralMapping: "Integral Mapping",
		previewResource: 'Preview Resource',
		liveReview: "Live Review",
		liveManagement: "Live Management",
		liveList: "Live List",
		liveConfiguration: "Live Configuration",
		ADManagement: 'AD Management',
		liveAudienceList: "Live Audience List",
		liveMemberList: "Live Member List",
		hierarchicalDiagnosis: "Hierarchical Diagnosis",
		ultrasonic: "Ultrasonic",
		ultrasonicDetail: "Ultrasonic Detail",
		ultrasonicGroups: "Ultrasonic Groups",
		ultrasonicGroupsDetail: "Ultrasonic Groups Detail",
		ultrasonicGroupsMember: "Ultrasonic Groups Member",
		ultrasonicGroupsPost: "Ultrasonic Groups Post",
		eventSquare: "Event Square",
		eventDetail: "Event Detail",
		videoCourse: "Video Course",
		videoDetail: 'Video Detail',
		quizManagement: "Quiz Management",
		quizDetail: "Quiz Detail",
		CarouselManagement: "Carousel Management",
		ModuleManagement: 'Module Management',
		ModuleCustomization: 'Module Customization',
		NotificationManagement: "Notification Management",
		customerService: "Customer Service",
		statisticsManagement: "Statistics Management",
		integralStatistics: "Integral Statistics",
		liveStatistics: 'Live Statistics',
		statistics: "Statistics",
		userStatistics: "User Statistics",
		appManagement: "APP Management",
		versionManagement: "Version Management",
		downloadManagement: "Download Management",
		systemManagement: "System Management",
		RoleManagement: 'Role Management',
		authorityManagement: "Authority Management",
		PermissionList: "Permission List",
		instrumentManagement: "Instrument Management",
		staffManagement: "Staff Management",
		expertManagement: "Expert Management",
		userManagement: "User Management",
		netDiskManagement: "Net Disk Management",
		diagnosisManagement: "Diagnostic Management",
		roleApplicationManagement: "Diagnostic Role Application Management",
		roleUserManagement: "Diagnostic Role User Management",
		teamManagement: "Diagnostic Team Management",
		diagnosticTeamDetail: "Diagnostic Team Detail",
		diagnosticTeamMember: "Diagnostic Team Member Management",
		diagnosticUserDetail: "Diagnostic Role Detail",
		userDetail: "User Detail",
		resourceManagement: "Internal Resource Management",
		contentSecurity: "Content Security",
		productionInfoManagement: "Production Information Management",
		learningMaterialsManagement: 'Learning Materials Management',
		userFeedback: "User Feedback",
		contactUs: "Contact Us",
		officialWebsite: "Official Website",
		CSDocumentManagement: "CS Document Management",
		file: "file",
		instrument: "instrument",
		user: "user",
		FileManagement: 'File Management',
		tagManagement:"Condition Management",
		uploadFile:"File Upload",
		fileDetail:"File Edit",
		manageFileType:"FileType Management",
		classificationManagement:"Classification Management",
		uploadLearningFile:"File Upload",
		resourceApply:"Resource Apply",
		accessConfig:"Access Config",
		ConditionDetail:"Property Setting"
	},

	// Login&Longout
	login: {
		language: "Language",
		// zh: "Chinese",
		en: "English",
		SIUICloudLogin: "SIUI Cloud",
		username: "Username",
		usernameTips: "Please enter the correct user name",
		password: "Password",
		passwordTips: "The password can not be less than 6 digits",
		login: "Log in",
		logout: "Log out",
		registered: "Registered",
		forgetPassword: "Forget Password",
	},

	// 主页
	home: {},

	// 云存储
	cloudStorage: {},

	// 云咨询
	cloudConsultation: {},

	// 云教学
	cloudTeaching: {},

	// 云客服
	cloudService: {},

	// 麦粒医生
	mai: {},

	// 统计管理
	statisticsManagement: {},

	// 应用管理
	appManagement: {},

	// 系统管理
	systemManagement: {
		// CS Document
		CSDocument: {
			fileList: "File List",
			resourceType: "Resource Type",
			filterCondition: 'Filter Condition',
			instrumentSeries: "Instrument Series",
			userList: "User List",
			userReview: "User Review",
			userApplication: "User Application",
			userRecord: "User Record",
			userRole: "User Role",
			view: "View",
			download: "Download",
			approve: "Approve",
			unapprove: "Unapprove",
		},
	},

	// 联系我们
	contactUs: {},
};
